<template>
	<div class="home">
		<Tophead :app-name="home.name" :app-logo="home.logo" />
		<DownloadBtn :apk="apk" :pageName="pageName" :from="from" :pkgName="pkgName" />
		<section id="section-1" class="section-content">
			<h1 class="section-1-rule" v-html="doc.s1.h1"></h1>
			<div class="security-memo">
				<img src="@/assets/home/securit.png" alt="security">
				{{doc.s1.ad}}
			</div>
			<img src="@/assets/home/1.png" :src-data="doc.loadingImg.p1" alt="phone" class="phone loadimg">
		</section>

		<section id="section-2" class="section-content section-2">
			<div class="section-2-content-row">
				<p v-html="doc.s2.content"></p>
				<h2 v-html="doc.s2.h2"></h2>
			</div>

			<div class="s2-img-row">
				<img src="@/assets/home/2.png" :src-data="doc.loadingImg.p2" alt="phone" class="phone loadimg phone2">
			</div>
		</section>

		<section id="section-3" class="section-content">
			<h2 class="section-3-rule h2-rules" v-html="doc.s3.h1"></h2>
			<img src="@/assets/home/3.png" :src-data="doc.loadingImg.p3" alt="phone3" class="phone loadimg phone3">
			<p class="section-normal-content" v-html="doc.s3.content"></p>
		</section>

		<section id="section-4" class="section-content section-4">
			<h2 class="section-4-rule h2-rules color-white" v-html="doc.s4.h1"></h2>
			<img src="@/assets/home/4.png" :src-data="doc.loadingImg.p4" alt="phone4" class="phone loadimg phone4">
			<p class="section-normal-content m-b-40 color-white" v-html="doc.s4.content1"></p>
		</section>

		<section class="section-content section-5">
			<h2 class="section-5-rule h2-rules" v-html="doc.s5.h1"></h2>
			<img src="@/assets/home/5.png" :src-data="doc.loadingImg.p5" alt="phone5" class="phone loadimg phone5">
			<p class="section-normal-content m-b-40" v-html="doc.s5.content1"></p>
		</section>

		<section class="section-content section-6">
			<h2 class="section-6-rule h2-rules color-white" v-html="doc.s6.h1"></h2>
			<img src="@/assets/home/6.png" :src-data="doc.loadingImg.p6" alt="phone6" class="phone loadimg phone6">
			<p class="section-normal-content m-b-40 color-white" v-html="doc.s6.content1"></p>
		</section>

		<section class="section-content section-7">
			<h2 class="section-7-rule h2-rules" v-html="doc.s7.h1"></h2>
			<img src="@/assets/home/7.png" :src-data="doc.loadingImg.p7" alt="phone7" class="phone loadimg phone7">
			<p class="section-normal-content m-b-40" v-html="doc.s7.content1"></p>
		</section>

		<faq :doc="doc"></faq>

		<Footr :app-name="home.name" :app-logo="home.footLogo" />
	</div>
</template>

<script>
import "@/css/home/mobile.scss";
import Tophead from "@/components/mobile/Tophead.vue";
import Footr from "@/components/mobile/Footr.vue";
import DownloadBtn from "@/components/mobile/DownloadBtn.vue";
import faq from "@/components/mobile/faq.vue";

export default {
	name: "mobile",
	components: {
		Tophead,
		Footr,
		DownloadBtn,
		faq,
	},
	data() {
		return {
			pageName: "mobile",
			doc: null,
			home: null,

			apk: null,
			from: "life",
			filename: "life",
			pkgName: null,
		};
	},
	created() {
		this.home = this.$store.state.home;
		this.doc = this.home.doc;
	},
	mounted() {
		this.apk = process.env.VUE_APP_VMLSHADOW_DEFAULT;

		this.getAPK();

		this.$global.img_loading();
	},
	methods: {
		getAPK() {
			this.$api
				.getAPK({
					from: this.from,
					filename: this.filename,
				})
				.then((res) => {
					console.log(res);
					if (res) {
						this.apk = res.apk;
						this.pkgName = res.version + "_" + this.filename;
					} else {
						this.pkgName = "9.9999_fail";
					}
					this.$reportInstance.report({
						time: new Date(),
						apk_full_path: this.apk,
						message: "browse_home_" + this.pageName,
						channel: this.from,
						pkgName: this.pkgName,
						method: "browse",
					});
				});
		},
	},
	metaInfo() {
		return {
			title: "VidMate - VidMate App Download Free Install for Android 2021",
			meta: [
				{
					name: "viewport",
					content:
						"width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no",
				},
				// {
				// 	vmid: "description",
				// 	name: "description",
				// 	content: "this.description",
				// },
			],
		};
	},
};
</script>
